import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {LoaderComponent} from './loader/loader.component';
import {LabelComponent} from './label/label.component';
import {ChildrenSelectorComponent} from './children-selector/children-selector.component';
import {MessageEntitySelector2Component} from './message-entity-selector2/message-entity-selector2.component';
import {ParentSelectorComponent} from './parent-selector/parent-selector.component';
import {
    NbCardModule,
    NbMenuModule,
    NbPopoverModule,
    NbStepperModule,
    NbThemeModule,
    NbUserModule
} from '@nebular/theme';
import {ChatComponent} from './chat/chat.component';
import {MessengerComponent} from './messenger/messenger.component';
import {FormsModule} from '@angular/forms';
import {EntitySelectorComponent} from './entity-selector/entity-selector.component';
import {MessageEntitySelectorComponent} from './message-entity-selector/message-entity-selector.component';
import {LinkyModule} from 'ngx-linky';
import {MenuComponent} from './menu/menu.component';
import {RouterModule} from '@angular/router';
import {ReplaceProfileImageButtonComponent} from './replace-profile-image-button/replace-profile-image-button.component';
import {InfiniteScrollModule} from 'ngx-infinite-scroll';
import {ChatChannelComponent} from './chat-channel/chat-channel.component';
import {MassMessengerComponent} from './mass-messenger/mass-messenger.component';
import {MassMessengerGroupFilterFormComponent} from './mass-messenger-group-filter-form/mass-messenger-group-filter-form.component';
import {MassMessengerLocationFilterFormComponent} from './mass-messenger-location-filter-form/mass-messenger-location-filter-form.component';
import {MassMessengerEntitySelectorFormComponent} from './mass-messenger-entity-selector-form/mass-messenger-entity-selector-form.component';
import {MassMessengerMessageComposerFormComponent} from './mass-messenger-message-composer-form/mass-messenger-message-composer-form.component';
import {MassMessengerStatusFormComponent} from './mass-messenger-status-form/mass-messenger-status-form.component';
import {CKEditorModule} from 'ng2-ckeditor'
import {NgSelectModule} from '@ng-select/ng-select'
import {NgbDatepickerModule} from '@ng-bootstrap/ng-bootstrap';


@NgModule({
    imports: [
        CommonModule,
        NbUserModule,
        NbThemeModule,
        NbCardModule,
        FormsModule,
        LinkyModule,
        RouterModule,
        NbMenuModule,
        NbPopoverModule,
        InfiniteScrollModule,
        NgSelectModule,
        NbStepperModule,
        CKEditorModule,
        NgbDatepickerModule,
    ],
    exports: [
        LoaderComponent,
        LabelComponent,
        ChildrenSelectorComponent,
        MessageEntitySelector2Component,
        ParentSelectorComponent,
        ChatComponent,
        MessengerComponent,
        EntitySelectorComponent,
        MessageEntitySelectorComponent,
        MenuComponent,
        ReplaceProfileImageButtonComponent,
        ChatChannelComponent,
    ],
    declarations: [
        LoaderComponent,
        LabelComponent,
        ChildrenSelectorComponent,
        MessageEntitySelector2Component,
        ParentSelectorComponent,
        ChatComponent,
        MessengerComponent,
        EntitySelectorComponent,
        MessageEntitySelectorComponent,
        MenuComponent,
        ReplaceProfileImageButtonComponent,
        ChatChannelComponent,
        MassMessengerComponent,
        MassMessengerGroupFilterFormComponent,
        MassMessengerLocationFilterFormComponent,
        MassMessengerEntitySelectorFormComponent,
        MassMessengerMessageComposerFormComponent,
        MassMessengerStatusFormComponent,
    ],
})
export class GlobalModule {

}
